import React from "react";

function Icon(props) {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="13"
            fill="none"
            viewBox="0 0 14 13"
        >
            <g fill="#fff" opacity="0.6">
                <path d="M2.152 6.5l10.696 6.175V.325L2.152 6.5z"></path>
                <path d="M2 12H4V23H2z" transform="rotate(180 2 12)"></path>
            </g>
        </svg>
    );
}

export default Icon;
